<template>
  <a-modal :closable="false" :footer="null" :visible="visible" :width="800" cancelText="不同意" title="《安全协议》">
    <div class="flex h-[60vh]">
      <iframe
        frameborder="0"
        height="100%"
        src="http://152.136.170.191:8890/web/#/p/8f18881afb3310e5c4d66cc31448485c"
        width="100%"
      ></iframe>
    </div>

    <div class="flex justify-center mt-8">
      <a-button :disabled="!isButtonEnabled" @click="confirm('ok')" class="mr-8" type="primary">{{ buttonText }}</a-button>

      <a-button @click="confirm('cancel')">我不同意</a-button>
    </div>
  </a-modal>
</template>
  
  <script>
  export default {
    data () {
      return {
        visible: false,
        userInfo: null,
        isButtonEnabled: false,
        buttonText: '倒计时: (5)秒',
        countdown: 5,
        timer: null,
      };
    },
    methods: {
      show (userInfo) {
        this.userInfo = userInfo;
        this.visible = true;
        this.startCountdown()
      },
      startCountdown () {
        this.timer = setInterval(() => {
          this.countdown--;
          this.buttonText = `倒计时: (${this.countdown})秒`;

          if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.buttonText = '我同意';
            this.isButtonEnabled = true;
          }
        }, 1000);
      },
      handleAgree () {
        // 调用接口修改同意时间
        this.updateAgreementTime();
      },
      updateAgreementTime () {
        console.log("用户同意安全声明，更新同意时间。");
        this.showModal = false;
        // 这里可以添加调用接口的代码
      },
      confirm (type) {
        this.$emit(type)

        //每次重置
        clearInterval(this.timer);
        this.visible = false;
        this.countdown = 5;
        this.buttonText = '倒计时: (5)秒';
        this.isButtonEnabled = false;

      }
    },

  };
  </script>
  
  <style scoped>

  .modal {
    /* 样式可以根据需要调整 */
    border: 1px solid #ccc;
    padding: 20px;
    background-color: #fff;
  }

</style>